import { render, staticRenderFns } from "./TrailerStatusModal.vue?vue&type=template&id=9398156e&scoped=true"
import script from "./TrailerStatusModal.vue?vue&type=script&lang=js"
export * from "./TrailerStatusModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9398156e",
  null
  
)

export default component.exports